export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCEEDED = 'GET_PROFILE_SUCCEEDED';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCEEDED = 'UPDATE_PROFILE_SUCCEEDED';
export const UPDATE_PROFILE_FAILED = 'UPDATE_PROFILE_FAILED';

export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const UPDATE_SETTINGS_SUCCEEDED = 'UPDATE_SETTINGS_SUCCEEDED';

export const UPDATE_AVATAR = 'UPDATE_AVATAR';
export const UPDATE_AVATAR_SUCCEEDED = 'UPDATE_AVATAR_SUCCEEDED';

export const LOADING_NEW_AVATAR_DONE = 'LOADING_NEW_AVATAR_DONE';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED';